import React from "react";
import { Wordmark } from "./Wordmark";
import { FOOTER } from "../data/copy";

/**
 * Section 9 — Footer. Graphite. Compliance line ("food supplement"),
 * reserved ingredients/allergen link.
 */
export const Footer = () => {
  return (
    <footer id="footer" className="mk-footer" data-testid="footer">
      <div className="mk-footer__top">
        <a href="#hero" className="mk-footer__brand" aria-label="mintikk home">
          <Wordmark />
        </a>
        <nav className="mk-footer__links" aria-label="Footer">
          {FOOTER.links.map((l) => (
            <a key={l} href="#" data-testid={`footer-link-${l.split(" ")[0].toLowerCase()}`}>
              {l}
            </a>
          ))}
        </nav>
      </div>
      <div className="mk-footer__bottom">
        <span data-testid="footer-compliance">{FOOTER.line}</span>
        <span>{FOOTER.url}</span>
      </div>
    </footer>
  );
};

export default Footer;
